export let OverviewSource;

(function (OverviewSource) {
  OverviewSource["Search"] = "filterable-results";
  OverviewSource["RecommendationsProgress"] = "recommendations-progress";
  OverviewSource["RecommendationsInterest"] = "recommendations-interest";
  OverviewSource["RecommendationsField"] = "recommendations-field";
  OverviewSource["Certificates"] = "certificates";
  OverviewSource["Software"] = "featured-software";
  OverviewSource["Wizard"] = "wizard-results";
  OverviewSource["SavedItems"] = "favourites-results";
  OverviewSource["MyPlaylists"] = "my-playlists";
  OverviewSource["Playlist"] = "playlist";
})(OverviewSource || (OverviewSource = {}));

export const EnabledOverviewNavigationSources = [OverviewSource.Playlist];